import { categories } from '@/mocks/categories';
import { homeContent } from '@/mocks/content';

const featuredImages: Record<string, string> = {
  shoes: 'https://readdy.ai/api/search-image?query=Premium%20product%20photography%20of%20two%20pairs%20of%20lifestyle%20sneakers%20one%20white%20one%20beige%20casually%20placed%20on%20light%20cream%20textured%20rug%20with%20soft%20natural%20window%20light%20gentle%20shadows%20editorial%20minimalist%20fashion%20composition%20warm%20neutral%20tones&width=600&height=450&seq=feat-shoes-v2-unique&orientation=landscape',
  hoodies: 'https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20a%20chunky%20knit%20oatmeal%20colored%20sweater%20elegantly%20draped%20on%20light%20linen%20fabric%20with%20dried%20botanical%20elements%20scattered%20soft%20diffused%20natural%20light%20editorial%20fashion%20photography%20calm%20Scandinavian%20aesthetic&width=600&height=450&seq=feat-hoodies-v2-unique&orientation=landscape',
  tshirts: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20three%20pastel%20toned%20cotton%20tshirts%20in%20blush%20sage%20and%20cream%20colors%20neatly%20stacked%20on%20light%20wood%20surface%20with%20soft%20natural%20daylight%20editorial%20minimal%20style%20gentle%20shadows%20warm%20neutral%20composition&width=600&height=450&seq=feat-tshirts-v2-unique&orientation=landscape',
};

export default function FeaturedCategories() {
  const featured = categories.slice(0, 3);

  return (
    <section id="categories" className="py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">
            {homeContent.sectionFeaturedTitle}
          </h2>
          <p className="text-base md:text-lg text-foreground-500">
            {homeContent.sectionFeaturedSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featured.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-background-100 hover:bg-accent-50 transition-colors cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={featuredImages[cat.id]}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold group-hover:bg-accent-500 transition-colors whitespace-nowrap">
                  Перейти
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}